import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import baseUrl from "../../config/baseUrl";
import getClientName from "../../api/getClientName";
import Loading from "../material-ui/Loading";

// Inline "Client Information" tab content - DMS-local data only (getCaseStatus
// + getClientName, same source BusinessCardInfo's hover popover uses
// elsewhere on this page). Deliberately NOT built on BusinessCardInfo's
// popover shell (info icon + hover-triggered floating card) - that pattern
// is correct for the header's small info icon, but wrong for a tab that's
// already visible; this renders the same data directly as a static table.
const ClientInfoPanel = ({ clientID, initialClientData }) => {
  const [clientData, setClientData] = useState(initialClientData || null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const fetchClientData = async (clientId) => {
    try {
      setLoading(true);

      const [caseStatusResponse, clientNameResponse] = await Promise.all([
        fetch(`${baseUrl}/api/getCaseStatus?caseId=${clientId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        getClientName({ contact_id: clientId, token }),
      ]);

      const data = await caseStatusResponse.json();
      const caseDetail = data?.caseDetails?.[0];

      setClientData({
        name: clientNameResponse?.data?.name || "",
        caseid_c: caseDetail?.caseid_c || "",
        phone_mobile: caseDetail?.phone_mobile || "",
        email: caseDetail?.email_id || "",
      });
    } catch (error) {
      console.error("Error fetching client data:", error);
      setClientData(initialClientData || null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientID && clientID !== "null") {
      fetchClientData(clientID);
    } else {
      setClientData(null);
    }
  }, [clientID, token]);

  if (!clientID || clientID === "null") {
    return (
      <div className="px-3 py-4 text-sm text-gray-400">
        Select a client to view their information.
      </div>
    );
  }

  if (loading && !clientData) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loading />
      </div>
    );
  }

  const rows = [
    { label: "Client Name", value: clientData?.name },
    { label: "Client Reference Number", value: clientData?.caseid_c },
    { label: "Phone Number", value: clientData?.phone_mobile },
    { label: "Email Address", value: clientData?.email },
  ];

  return (
    <div className="client-info-panel rounded-md border border-gray-200">
      <table className="w-full text-sm">
        <tbody>
          {rows.map((row) => (
            <tr key={row.label} className="border-b border-gray-100 last:border-b-0">
              <td className="px-3 py-2 w-1/3 text-gray-500 font-medium bg-gray-50">
                {row.label}
              </td>
              <td className="px-3 py-2 text-gray-900">{row.value || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClientInfoPanel;
